import React from 'react';
import { CaretRightOutlined } from '@ant-design/icons';

import IntroductionSection from './IntroductionSection';
import ResearchAndNewsSection from './ResearchAndNewsSection';
import TeachingAndContactSection from './TeachingAndContactSection';
import EducationSection from './EducationSection';
import LifePage from './LifePage';

interface HomePageProps {
  textContent: any;
}

const HomePage: React.FC<HomePageProps> = (props) => {
  const { textContent } = props;
  return (
    <>
      <IntroductionSection textContent={textContent} />
      {/* <EducationSection /> */}
      <ResearchAndNewsSection />
      <TeachingAndContactSection />
      {/* <LifePage /> */}
     </>
  )
};

export default HomePage;